import { cn } from "@omni/utils/styles";
import { FieldValues, Path, useController } from "react-hook-form";

import { FormFeedback as FormFeedbackComponent } from "@/components/Form/Base/formFeedback.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { calculateFieldState } from "../Utils/form.helpers";

type FormFeedbackProps<T extends FieldValues, TPath extends Path<T>> = {
    name: TPath;
    label: string;
    className?: string;
};

const FormFeedback = <T extends FieldValues, TPath extends Path<T>>({
    name,
    label,
    className
}: FormFeedbackProps<T, TPath>) => {
    const { fieldState, formState } = useController<T, TPath>({ name });
    const { t } = useGranite();

    const newFieldState = calculateFieldState<T>(fieldState, formState);

    if (
        !newFieldState.isInvalid ||
        !fieldState.error ||
        typeof fieldState.error.message !== "function"
    ) {
        return null;
    }

    const message = fieldState.error.message?.(label.toLowerCase())?.(t);

    if (!message) {
        return null;
    }

    return (
        <FormFeedbackComponent
            className={cn("tw:group-[*]/formgrouptoggle:-ml-5", className)}
        >
            {message}
        </FormFeedbackComponent>
    );
};

export { FormFeedback };
